import { useDispatch, useSelector } from 'react-redux';
import { pipe } from 'fp-ts/function';
import { selectIsFrequencyManageOptimizeFlagOn } from 'core/userContext';
import { useCoreContext } from 'modules/frequencyManagement/contexts/CoreContext';
import { GhostButton, BUTTON_SIZES } from 'ui/button';
import { addPositiveToast } from 'modules/toastContainer';
import { Export16 } from 'ui/icons';
import { downloadAsCsvFileWithHeaders } from 'utils/csv';
import { formatCSVFilenameDate } from 'modules/frequencyManagement/commonUtils';
import { convertToString } from 'utils/datetime';
import { TopTooltip } from 'ui/tooltip';
import { optimizeCSVDataHeaders } from 'modules/frequencyManagement/contexts/contextUtils';

export const createExportCSVFileName = (formattedData: string) =>
  `frequency_optimization_export_${formattedData}.csv`;

export const testExportButtonId = 'test-export-button';
export const ExportDisabledText = 'Frequency Optimization data is unavailable for export';

export const ExportCSV = () => {
  const dispatch = useDispatch();
  const { getOptimizeCSVData } = useCoreContext();
  const { hasCSVData, csvData } = getOptimizeCSVData();
  const isOptimizeEnabled = useSelector(selectIsFrequencyManageOptimizeFlagOn);
  const onDownloadCsv = () => {
    downloadAsCsvFileWithHeaders({
      headers: optimizeCSVDataHeaders,
      data: csvData,
      fileName: pipe(new Date(), convertToString, formatCSVFilenameDate, createExportCSVFileName),
    });
    dispatch(addPositiveToast('Success! Frequency management data exported.'));
  };
  const isCSVDisabled = !isOptimizeEnabled || !hasCSVData;
  return isOptimizeEnabled ? (
    <TopTooltip tooltipContent={ExportDisabledText} isEnabled={isCSVDisabled}>
      <GhostButton
        data-test={testExportButtonId}
        isDisabled={isCSVDisabled}
        onClick={onDownloadCsv}
        size={BUTTON_SIZES.LARGE}
      >
        <Export16 />
        Export CSV
      </GhostButton>
    </TopTooltip>
  ) : null;
};
